"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var CheckboxToggle = function CheckboxToggle(props) {
  return _react["default"].createElement(_Checkbox["default"], (0, _extends2["default"])({
    isToggle: true
  }, props));
};
CheckboxToggle.displayName = 'CheckboxToggle';
var _default = CheckboxToggle;
exports["default"] = _default;
CheckboxToggle.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CheckboxToggle"
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["Checkbox/CheckboxToggle.tsx"] = {
    name: "CheckboxToggle",
    docgenInfo: CheckboxToggle.__docgenInfo,
    path: "Checkbox/CheckboxToggle.tsx"
  };
}